/** @jsx jsx */
import { jsx } from '@emotion/core';
import DocumentFilledIcon from '@atlaskit/icon/glyph/document-filled';
import { N50, N90 } from '@atlaskit/theme/colors';
import { fontSize } from '@atlaskit/theme/constants';
import { Frame } from '../components/Frame';
import { gs } from '../utils';
export var ResolvingView = function (_a) {
    var _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, testId = _a.testId;
    return (jsx(Frame, { compact: true, isSelected: isSelected, testId: testId },
        jsx(DocumentFilledIcon, { size: "small", primaryColor: N50, label: "document-icon" }),
        jsx("span", { css: { fontSize: fontSize() + "px", color: N90, marginLeft: gs(0.5) } }, "Loading...")));
};
//# sourceMappingURL=ResolvingView.js.map